import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './authHelpers';

export default function ProtectedRoute({ children }: { children: React.ReactNode}): React.JSX.Element {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">Loading...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated, preserving the intended destination
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
